import { CheckCircle2, Phone } from "lucide-react";
import { CONTACT, OWNERS_IMAGE } from "@/data/content";

const points = [
  "Family-owned & operated in Northeast Florida",
  "Trusted by builders, developers & local businesses",
  "Hands-on owners on every account",
  "Active members of the Daytona community",
];

export const OwnersBanner = () => {
  return (
    <section data-testid="owners-banner" className="py-24 sm:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 grid lg:grid-cols-2 gap-14 items-center">
        <div className="relative order-2 lg:order-1">
          <div className="bg-[#1c4f9c] rounded-sm p-3 shadow-xl">
            <img
              src={OWNERS_IMAGE}
              alt="Elite Commercial Cleaning Service owners at the Rolex 24 at Daytona"
              loading="lazy"
              decoding="async"
              className="w-full h-auto rounded-sm"
            />
          </div>
        </div>
        <div className="order-1 lg:order-2">
          <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#e02329] mb-3">Locally Owned & Operated</p>
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-[#1c4f9c]">
            Real people. Real pride. Real results.
          </h2>
          <p className="mt-5 text-base text-slate-600 leading-relaxed">
            Elite Facility Solutions is a locally owned commercial cleaning company built on hard work and accountability. When you hire us, you work directly with owners who care about your facility as much as you do — from new construction job sites to daily janitorial routes across the Daytona area.
          </p>
          <ul className="mt-8 grid sm:grid-cols-2 gap-4">
            {points.map((p) => (
              <li key={p} className="flex items-start gap-3">
                <CheckCircle2 size={20} className="text-[#e02329] shrink-0 mt-0.5" />
                <span className="text-sm font-medium text-slate-700">{p}</span>
              </li>
            ))}
          </ul>
          <a
            href={CONTACT.phoneHref}
            data-testid="owners-call-btn"
            className="inline-flex mt-9 items-center justify-center gap-2 bg-[#e02329] text-white font-bold py-4 px-8 rounded-sm hover:bg-[#c81e24] transition-colors duration-200"
          >
            <Phone size={18} strokeWidth={2.5} /> Talk to the Owners — {CONTACT.phone}
          </a>
        </div>
      </div>
    </section>
  );
};
